import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from 'emotion-theming';
import Color from 'color';
import IcomoonReact from 'icomoon-react';

import iconSet from '../../../../shared/images/teambuildr-selection.json';

import { fetchFeedPRCount } from '../../ducks/feedActions';
import { feedTracker } from '../../../../shared/utils/amplitudeHelper';

const BottomDiv = styled('div')`
  height: 25px;
`;

const CloseButton = styled('button')`
  align-self: center;
  height: 20x;
  font-size: 20px;
  font-weight: 500;
  border: 0px;
  cursor: pointer !important;
`;

const CloseWidgetDiv = styled('div')`
  height: 25px;
  text-align: end;
  padding-right: 10px;
`;

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 420px;
  margin: 0 auto 30px auto;
  height: 200px;
  background: ${(props) => `linear-gradient(134deg, ${props.colorAccent} -8%, ${props.darkerColorAccent} 200%)`};
  color: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  @media screen and (max-width: 1200px) {
    height: 300px;
    min-height: 300px;
    width: 250px;
  }
`;

const MedalIconWrapper = styled('span')`
  height: 100%;
  width: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 1200px) {
    height: 80px;
  }
`;

const TotalPrsCount = styled('div')`
    font-size: 80px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 400;
    margin: 0;
    line-height: 80px;
    padding: 10px 0;
    color: #ffffff;
`;

const TotalPrsText = styled('div')`
  display: block;
  color: #ffffff;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 20px;
  line-height: 20px;
  font-weight: 900;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  margin-bottom: 10px;
  margin-top: 5px;
  @media screen and (max-width: 1200px) {
    margin-bottom: 0;
  }
`;

const WidgetSelectionContainer = styled('div')`
  width: 400px;
  height: 150px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 1200px) {
    width: 180px;
    height: 200px;
    text-align: center;
  }
`;

const WidgetTextDiv = styled('span')`
  height: 100%;
  width: 310px;
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media screen and (max-width: 1200px) {
    padding-left: 0;
  }
`;

const TotalPrsWidget = ({ setDisplayWidget }) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const feedPRCount = useSelector((state) => state.feed.data.feedPRCount);
  const selectedGroups = useSelector((state) => state.feed.data.selectedGroups);

  const dispatch = useDispatch();
  const theme = useTheme();

  const themeColor = theme.colorAccent ? theme.colorAccent : '#FFFFFF';
  const colorAccent = Color(themeColor);
  const darkerColorAccent = colorAccent.darken(0.5);

  useEffect(() => {
    dispatch(fetchFeedPRCount(currentUser.accountCode));
  }, [JSON.stringify(selectedGroups)]);

  const handleCloseWidget = () => {
    setDisplayWidget(false);
    feedTracker('TV Mode', 'Total PRs widget closed');
  };

  return (
    <Container colorAccent={colorAccent} darkerColorAccent={darkerColorAccent}>
      <CloseWidgetDiv>
        <CloseButton onClick={handleCloseWidget}>
          <IcomoonReact
            iconSet={iconSet}
            size={12}
            icon='remove'
            color='#ffffff'
          />
        </CloseButton>
      </CloseWidgetDiv>
      <WidgetSelectionContainer>
        <MedalIconWrapper>
          <IcomoonReact
            iconSet={iconSet}
            size={80}
            icon='ribbon'
            color='#ffffff'
          />
        </MedalIconWrapper>
        <WidgetTextDiv>
          <TotalPrsText>TOTAL PRS TODAY:</TotalPrsText>
          <TotalPrsCount>{feedPRCount}</TotalPrsCount>
        </WidgetTextDiv>
      </WidgetSelectionContainer>
      <BottomDiv />
    </Container>
  );
};

TotalPrsWidget.propTypes = {
  setDisplayWidget: PropTypes.func.isRequired,
};

export default TotalPrsWidget;
